var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreenMaximize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.703,
    height: 25.703,
    viewBox: "0 0 25.703 25.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fullscreen-Arrow-Arrows-Direction-User_Interface",
    "data-name": "Fullscreen-Arrow-Arrows-Direction-User Interface",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164572",
    "data-name": "Path 164572",
    d: "M46.77,39.679v6.2a.889.889,0,0,1-.886.886h-6.2a1.329,1.329,0,1,1,0-2.659h2.553l-6.43-6.43A1.329,1.329,0,0,1,37.681,35.8l6.43,6.43V39.679a1.329,1.329,0,0,1,2.659,0Z",
    transform: "translate(-18.067 -18.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164573",
    "data-name": "Path 164573",
    d: "M46.686,3.886v6.2a1.329,1.329,0,0,1-2.659,0V7.538l-6.43,6.43a1.329,1.329,0,1,1-1.879-1.879l6.43-6.43H39.6A1.329,1.329,0,0,1,39.6,3h6.2A.889.889,0,0,1,46.686,3.886Z",
    transform: "translate(-17.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164574",
    "data-name": "Path 164574",
    d: "M13.968,12.089a1.329,1.329,0,1,1-1.879,1.879l-6.43-6.43v2.553a1.329,1.329,0,0,1-2.659,0v-6.2A.889.889,0,0,1,3.886,3h6.2a1.329,1.329,0,0,1,0,2.659H7.538Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164575",
    "data-name": "Path 164575",
    d: "M13.968,35.761a1.327,1.327,0,0,1,0,1.879l-6.43,6.43h2.553a1.329,1.329,0,1,1,0,2.659h-6.2A.889.889,0,0,1,3,45.843v-6.2a1.329,1.329,0,0,1,2.659,0v2.553l6.43-6.43A1.329,1.329,0,0,1,13.968,35.761Z",
    transform: "translate(0 -18.026)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenMaximize);
export default __webpack_public_path__ + "static/media/Fullscreen-maximize.30efa6eba83034b24ae2cbb08089feb6.svg";
export { ForwardRef as ReactComponent };